<template>
	<div class="modal" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Ver solicitud</h4>
				</div>
				<div class="modal-body" v-if="request">
					<loading :active="loading">
						<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
					</loading>
					<ul class="nav nav-tabs" role="tablist">
						<li role="presentation" class="active">
							<a href="#data" aria-controls="data" role="tab" data-toggle="tab" aria-expanded="true">
								<span class="visible-xs">
									<i class="ti-home"></i>
								</span>
								<span class="hidden-xs"> Datos</span>
							</a>
						</li>
						<template v-if="media">
							<li v-if="media.length" role="presentation">
								<a href="#images" aria-controls="images" role="tab" data-toggle="tab" aria-expanded="true">
									<span class="visible-xs">
										<i class="ti-home"></i>
									</span>
									<span class="hidden-xs"> Imágenes</span>
								</a>
							</li>
						</template>
					</ul>
					<div class="tab-content">
						<div role="tabpanel" class="tab-pane active" id="data">
							<div class="row" v-if="data">
								<template v-if="data.length">
									<div v-for="field in data" class="col-md-12">
										<h4>{{ field.name }}:</h4>
										<div class="well well-sm" v-html="field.value"></div>
									</div>
								</template>
							</div>
						</div>
						<template v-if="media">
							<div v-if="media.length" role="tabpanel" class="tab-pane" id="images">
								<div class="row">
									<template v-for="value in media">
										<div class="col-md-6 m-b-20">
											<template v-if="value.base64">
												<a :href="value.base64" data-toggle="lightbox" data-gallery="multiimages" :data-title="value.filename">
													<img :src="value.base64" class="img-responsive"/>
												</a>
											</template>
											<template v-else>
												<div style="height: 300px">
													<loading :active="true">
														<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
													</loading>
												</div>
											</template>
										</div>
									</template>
								</div>
							</div>
						</template>
					</div>
					<!-- -->
				</div>
				<div class="modal-footer">
					<button @click="openRequestEdit()" type="submit" class="btn btn-default">
						Editar
					</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'requests-show-' + new Date().getTime(),
				},

				request: null,
				data: null,
				media: null,
				loading: false,
			}
		},
		mounted() {
			var that = this
			$('#'+this.modal.selector).on('hidden.bs.modal', function () {
				that.request = null
			})
		},
		methods: {
			open(request) {
				if(request) {
					this.request = request
					this.loadData()
					this.getMedia()
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			loadData() {
				this.data = this.request.data
			},
			openRequestEdit() {
				this.close()
				this.$emit('openRequestEdit', this.request)
			},
			getMedia() {
				if(this.request) {
					this.loading = true
					this.$http.get('admin/requests/' + this.request.id + '/media/images')
					.then(response => {
						this.loading = false
						this.media = response.body
						this.loadImages()
					}).catch(response => {
						console.log(response)
						this.loading = false
					})
				}
			},
			loadImages() {
				if(this.media) {
					if(this.media.length) {
						var that = this
						this.media.forEach(function(media) {
							that.getBase64(media)
						})
					}
				}
			},
			getBase64(media) {
				this.$http.get('admin/media/' + media.id + '/base64')
				.then(response => {
					var base64 = response.body
					this.$set(media, 'base64', 'data:image/' + media.extension + ';base64,' + base64)
				}).catch(response => {
					console.log(response)
				})
			}
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/requests/views/Show.vue